enum WhitelabelTypeEnum {
    Gemtree = 'GEMTREE',
}

export default WhitelabelTypeEnum;